// Name of this module
export const NAME = 'header';

export const FETCH_CONSULTANTS_REQUEST = `${NAME}/FETCH_CONSULTANTS_REQUEST`;
export const FETCH_CONSULTANTS_SUCCESS = `${NAME}/FETCH_CONSULTANTS_SUCCESS`;
export const FETCH_CONSULTANTS_FAILURE = `${NAME}/FETCH_CONSULTANTS_FAILURE`;
export const TOGGLE_CONSULTANTS = `${NAME}/TOGGLE_CONSULTANTS`;
